<template>
  <div class="ManagerReimbursementList">
    <div class="pageFilter" v-if="filterShow">
      <div class="pageFilterLeft">
        <el-input
          size="small"
          class="filter-item"
          style="width: 200px"
          suffix-icon="el-icon-chaxun"
          placeholder="请输入报销编号"
          clearable
          v-model="keyword.Code"
          @clear="getList()"
          @keyup.native.enter="getList()"
        />
        <el-input
          size="small"
          class="filter-item"
          style="width: 200px"
          suffix-icon="el-icon-chaxun"
          placeholder="请输入报销人"
          clearable
          v-model="keyword.ApplyUserName"
          @clear="getList()"
          @keyup.native.enter="getList()"
        />
        <el-select
          size="small"
          class="filter-item"
          style="width: 200px"
          placeholder="请选择部门筛选"
          v-model="keyword.CostDeptId"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            :label="item.Title"
            :value="item.ID"
            v-for="(item, idx) in orgList"
            :key="idx"
          />
        </el-select>
        <el-select
          size="small"
          class="filter-item"
          style="width: 200px"
          placeholder="请选择财务打款"
          v-model="keyword.IsFinancialPaid"
          filterable
          clearable
          @change="getList()"
        >
          <el-option label="是" :value="1" />
          <el-option label="否" :value="0" />
        </el-select>
        <el-date-picker
          class="filter-item"
          style="width: 240px"
          size="small"
          v-model="keyword.ApplyDateTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="daterange"
          range-separator="-"
          start-placeholder="申请开始日期"
          end-placeholder="申请结束日期"
          clearable
          @change="getList()"
        />
        <span>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-chaxun"
            round
            @click="getList()"
            >查询</el-button
          >
        </span>
        <span>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-qingkong"
            round
            @click="clearEvent()"
            >清空</el-button
          >
        </span>
        <span v-if="status === 1">
          <el-button
            type="warning"
            size="small"
            icon="el-icon-refresh-left"
            round
            :disabled="!rowData"
            @click="cancelOrder(rowData)"
            :loading="cancelLoad"
            >撤销</el-button
          >
        </span>
        <template v-if="isFinance || userInfo.UserName == 'Admin'">
          <span>
            <el-button
              type="success"
              size="small"
              icon="el-icon-daochu2"
              round
              :loading="exportExcelLoad"
              @click="exportExcel"
              >导出Excel表</el-button
            >
          </span>
          <span v-if="status === 2 || status === 1">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-tidangan"
              round
              :disabled="!rowData || rowData.IsSubmitInvoice"
              :loading="billLoad"
              @click="receipt('IsSubmitInvoice', '收取纸质发票')"
              >已收纸质发票</el-button
            >
          </span>
          <!-- <span v-if="status===2||status===1">
            <el-dropdown trigger="click" placement='bottom'>
              <el-button type="primary" size="small" icon="el-icon-tidangan" round :disabled="!rowData || (rowData.IsSubmitVoucher && rowData.IsSubmitInvoice)" :loading='billLoad'>已收单据 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :disabled="!rowData || rowData.IsSubmitVoucher" @click.native="receipt('IsSubmitVoucher','提交报销单')"> 报销单 </el-dropdown-item>
                <el-dropdown-item :disabled="!rowData || rowData.IsSubmitInvoice" @click.native="receipt('IsSubmitInvoice','收取纸质发票')"> 纸质发票 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span> -->
          <span v-if="!status">
            <el-button
              type="success"
              size="small"
              icon="el-icon-daochu2"
              round
              :disabled="!selIds.length"
              :loading="exportLoad"
              @click="exportPayApplyForm"
              >导出付款申请</el-button
            >
          </span>
          <span v-if="status === 2">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-_shijianguanli"
              round
              :disabled="
                !rowData ||
                rowData.FinancialPayTime ||
                rowData.Status == 4 ||
                rowData.Status == 1
              "
              @click="remitDateShow = true"
              >打款日期</el-button
            >
          </span>
        </template>
      </div>
      <div class="pageFilterRight">
        <el-button
          icon="el-icon-plus"
          size="small"
          round
          plain
          class="NewReimbursementForm"
          @click="$emit('toggle', { name: 'AddReimbursement' })"
          >新建报销单</el-button
        >
      </div>
    </div>
    <table-layout
      :isShowSelector="(isFinance || userInfo.UserName == 'Admin') && !status"
      tableName="ReimbursementCol"
      :tableColumn="tableColumn"
      :tableData="tableData"
      :total="total"
      :listLoading="tableLoad"
      :isLayout="filterShow"
      :isShowSerial="true"
      :operateColWidth="112"
      @row-click="rowClick"
      @pageChange="pageChange"
      @selectChange="selectChange"
    >
      <template v-slot:IsSubmitVoucher="{ row }">
        <span :style="{ color: row.IsSubmitVoucher ? '#3399FF' : '#FF4141' }">{{
          row.IsSubmitVoucher ? '是' : '否'
        }}</span>
      </template>
      <template v-slot:IsSubmitInvoice="{ row }">
        <span
          :class="{ yes: row.IsSubmitInvoice, deny: !row.IsSubmitInvoice }"
          >{{ row.IsSubmitInvoice ? '已收' : '未收' }}</span
        >
      </template>
      <template v-slot:IsFinancialPaid="{ row }">
        <span
          :class="{ yes: row.IsFinancialPaid, deny: !row.IsFinancialPaid }"
          >{{ row.IsFinancialPaid ? '已打款' : '未打款' }}</span
        >
      </template>
      <!-- 添加的审核状态 -->
      <template v-slot:Status="{ row }">
        <div>
          <el-tag type="info" v-if="row.Status == 0">草稿</el-tag>
          <el-tag type="warning" v-if="row.Status == 1">待审核</el-tag>
          <el-tag type="success" v-if="row.Status == 2">已通过</el-tag>
          <el-tag type="danger" v-if="row.Status == 4">已驳回</el-tag>
        </div>
      </template>
      <template v-slot:operate="{ row }">
        <div class="tabel-btns">
          <el-tooltip
            content="修改科目"
            placement="bottom"
            effect="light"
            v-if="
              (isFinance || userInfo.UserName == 'Admin') &&
              (status === 2 || status === 1)
            "
          >
            <el-button
              class="audit-button"
              size="mini"
              type="success"
              icon="el-icon-more"
              plain
              circle
              @click="openSubjectDialog(row)"
            />
          </el-tooltip>
          <el-tooltip content="详情" placement="bottom" effect="light">
            <el-button
              class="look-button"
              size="mini"
              type="primary"
              icon="el-icon-chakan"
              plain
              circle
              @click="$emit('toggle', { name: 'ReimbursementDetail', row })"
            />
          </el-tooltip>
        </div>
      </template>
    </table-layout>

    <el-dialog
      title="打款日期"
      :visible.sync="remitDateShow"
      center
      :close-on-click-modal="false"
      width="520px"
    >
      <el-form
        :model="{ remitDate }"
        class="dialogForm"
        label-width="175px"
        ref="remitDate"
      >
        <el-form-item
          prop="remitDate"
          label="打款日期："
          :rules="[
            { required: true, message: '不能为空', trigger: ['change'] }
          ]"
        >
          <el-date-picker
            v-model="remitDate"
            size="medium"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择打款日期"
            style="width: 240px"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            class="cancelWireless"
            size="medium"
            @click="remitDateShow = false"
            >取 消</el-button
          >
          <el-button
            size="medium"
            type="primary"
            :loading="remitDateLoad"
            @click="updateRemitDate"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="修改科目"
      :visible.sync="subjectShow"
      center
      :close-on-click-modal="false"
      width="800px"
    >
      <el-form
        :model="subjectForm"
        class="dialogForm"
        label-width="120px"
        ref="subjectForm"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              prop="CostCompanyId"
              label="公司主体："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择公司主体"
                style="width: 240px"
                clearable
                filterable
                v-model="subjectForm.CostCompanyId"
              >
                <el-option
                  v-for="item in InvoicingEntity"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.ID"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="OwnerCompanyName"
              label="抬头企业："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择抬头企业"
                style="width: 240px"
                clearable
                filterable
                v-model="subjectForm.OwnerCompanyName"
              >
                <el-option
                  v-for="item in issuerList"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="FinancialEntry"
              label="一级科目："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择一级科目"
                style="width: 240px"
                clearable
                filterable
                @change="subjectForm.FinancialSubEntry = ''"
                v-model="subjectForm.FinancialEntry"
              >
                <el-option
                  v-for="item in stairArr"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              prop="FinancialSubEntry"
              label="二级科目："
              :rules="[
                { required: true, message: '不能为空', trigger: ['change'] }
              ]"
            >
              <el-select
                size="medium"
                placeholder="请选择二级科目"
                style="width: 240px"
                clearable
                filterable
                :disabled="!subjectForm.FinancialEntry"
                v-model="subjectForm.FinancialSubEntry"
              >
                <el-option
                  v-for="item in filterSecondary"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.Name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            :span="12"
            v-for="(item, index) in subjectForm.FeeInfo"
            :key="index"
          >
            <el-form-item prop="Fees" :label="`费用事由${index + 1}：`">
              <div>
                <el-input
                  style="width: 240px"
                  v-model="item.FeeMemo"
                  placeholder="请输入费用事由"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item class="btnStyle">
              <el-button
                class="cancelWireless"
                size="medium"
                @click="subjectShow = false"
                >取 消</el-button
              >
              <el-button
                size="medium"
                type="primary"
                :loading="subjectLoad"
                @click="updateSubject"
                >确 定</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  basic,
  ReimbursementWorkflowUpdateData,
  orgQuery
} from '../../http/api'
import { fetchBatchSysDicList } from '../../http/dictionary'
import ReimbursementCol from '../../tableColumn/reimbursementCol'
export default {
  name: 'ReimbursementTable',
  components: {},
  props: ['filterShow', 'status', 'isFinance'],
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo') || '{}'),
      tableColumn: ReimbursementCol,
      InvoicingEntity: this.$InvoicingEntity,
      stairArr: this.$ReimburseSubject.filter(item => !item.ParentID),
      secondaryArr: this.$ReimburseSubject.filter(item => !!item.ParentID),
      filterSecondary: [],
      tableData: [],
      total: 0,
      tableLoad: false,
      remitDateShow: false,
      remitDateLoad: false,
      billLoad: false,
      cancelLoad: false,
      exportLoad: false,
      exportExcelLoad: false,
      subjectShow: false,
      subjectLoad: false,
      rowData: null,
      remitDate: '',
      selIds: [],
      subjectForm: {
        ReimbursementWorkflowId: 0, // 费用报销流程的id
        FinancialEntry: '', // 一级科目
        FinancialSubEntry: '', // 二级科目
        CostCompanyId: null, // 公司主体id
        CostCompanyName: '', // 公司主体名称
        OwnerCompanyName: '', // 抬头企业名称
        FeeInfo: [] // 费用事由
      },
      keyword: {
        Code: '',
        ApplyUserName: '', // 报销人
        IsFinancialPaid: null,
        ApplyDateTime: [],
        CostDeptId: null // 付款费用归属部门id
      },
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        order: 'ID desc',
        where: '1=1'
      },
      issuerList: [], // 抬头公司
      orgList: [] // 部门数据
    }
  },
  watch: {
    keyword: {
      handler (val, oldVal) {
        this.listQuery.where = this.filterWhere()
        for (let key in val) {
          if (val[key] !== '' && val[key] !== null) {
            switch (key) {
              case 'ApplyDateTime':
                if (val[key].length)
                  this.listQuery.where += ` and ${key}>='${val[key][0]}' and ${key}<'${val[key][1]}'`
                break
              case 'IsFinancialPaid':
                this.listQuery.where += ` and ${key} = ${val[key]}`
                break
              case 'CostDeptId':
                this.listQuery.where += ` and ${key} = ${val[key]}`
                break
              case 'ApplyUserName':
                this.listQuery.where += ` and ${key} = '${val[key]}'`
                break
              default:
                this.listQuery.where += ` and ${key} like '%${val[key]}%'`
                break
            }
          }
        }
      },
      deep: true
    },
    'subjectForm.FinancialEntry' (val) {
      if (val) {
        let find = this.stairArr.find(item => item.Name === val)
        let arr = this.secondaryArr.filter(item => item.ParentID === find.ID)
        this.filterSecondary = arr
      } else {
        this.filterSecondary = []
      }
    }
  },
  created () {
    this.listQuery.where = this.filterWhere()
    this.getOrgQuery()
    this.getList()
  },
  methods: {
    // 获取部门筛选数据
    getOrgQuery () {
      let dataParams = {
        order: 'order asc',
        select: 'ID,Order,OrgType,Title,ParentID,DepartmentType',
        where: ''
      }
      orgQuery(dataParams).then(res => {
        // console.log('获取部门筛选数据', res)
        this.orgList = res.filter(
          item => item.OrgType == 5 || item.OrgType == 1
        )
      })
    },
    selectChange (val) {
      this.selIds = val && val.length ? val.map(key => key.ID) : []
    },
    // 打开弹框回显数据
    /**
     * @param {*} row  当前点击的项
     */
    openSubjectDialog (row) {
      // for (const key in this.subjectForm) {
      //   this.subjectForm[key] = row[key]
      // }
      // 获取抬头企业数据
      fetchBatchSysDicList([
        {
          catalogName: 'OwnerCompanyName',
          sys: 'BasicData'
        }
      ]).then(res => {
        this.issuerList = res[0].Data
        // console.log('获取抬头企业数据', res)
      })
      // console.log('row', row)
      let rowCopy = JSON.parse(JSON.stringify(row))
      this.subjectForm.FeeInfo = []
      for (const key in this.subjectForm) {
        if (key === 'FeeInfo') {
          rowCopy.Fees.forEach(item => {
            this.subjectForm.FeeInfo.push({
              FeeId: +item.ID,
              FeeMemo: item.FeeMemo
            })
          })
        } else if (key === 'ReimbursementWorkflowId') {
          this.subjectForm.ReimbursementWorkflowId = rowCopy.ID
        } else {
          this.subjectForm[key] = rowCopy[key]
        }
      }
      this.subjectShow = true
    },
    exportPayApplyForm () {
      this.exportLoad = true
      this.$export(
        '/BasicData.ReimbursementWorkflow/ExportPayApplyForm',
        {
          ids: this.selIds
        },
        _ => {
          this.exportLoad = false
        }
      )
    },
    exportExcel () {
      this.exportExcelLoad = true
      this.$export(
        '/BasicData.ReimbursementWorkflow/ExportExcel',
        {
          request: {
            Code: this.keyword.Code,
            Status: this.status,
            IsFinancialPaid: this.keyword.IsFinancialPaid,
            ApplyDateTimeStart: this.keyword.ApplyDateTime.length
              ? this.keyword.ApplyDateTime[0]
              : null,
            ApplyDateTimeEnd: this.keyword.ApplyDateTime.length
              ? this.keyword.ApplyDateTime[1]
              : null
          }
        },
        _ => {
          this.exportExcelLoad = false
        }
      )
    },
    // 修改科目点击事件
    updateSubject () {
      this.$refs.subjectForm.validate(valid => {
        if (valid) {
          this.subjectLoad = true
          // 公司主体名称
          let find = this.InvoicingEntity.find(
            item => item.ID === this.subjectForm.CostCompanyId
          )
          this.subjectForm.CostCompanyName = (find && find.Title) || ''
          // console.log('this.subjectForm', this.subjectForm)
          // this.disposeUpdateQuery(this.subjectForm)
          // 财务修改科目
          ReimbursementWorkflowUpdateData(this.subjectForm)
            .then(_ => {
              this.subjectShow = false
              this.$message.success('操作成功！')
              this.getList()
            })
            .finally(_ => {
              this.subjectLoad = false
            })
        }
      })
    },
    // 打款日期弹框点击事件
    updateRemitDate () {
      this.$refs.remitDate.validate(valid => {
        if (valid) {
          this.remitDateLoad = true
          this.disposeUpdateQuery({
            FinancialPayTime: this.remitDate,
            IsFinancialPaid: true
          })
            .then(_ => {
              this.remitDateShow = false
              this.remitDate = this.$options.data.call(this).remitDate
            })
            .finally(_ => {
              this.remitDateLoad = false
            })
        }
      })
    },
    // 已收纸质发票点击事件
    receipt (field, name) {
      this.$confirm(
        `<i class='el-icon-warning'></i>此操作将确认已${name}, 是否继续?`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true,
          dangerouslyUseHTMLString: true,
          cancelButtonClass: 'cancelWireless'
        }
      ).then(() => {
        this.billLoad = true
        this.disposeUpdateQuery(field, true).finally(_ => {
          this.billLoad = false
        })
      })
    },
    // 撤销审核点击事件
    cancelOrder (rowData) {
      this.$confirm(
        `<i class='el-icon-warning'></i>此操作将撤销申请， 是否继续`,
        '撤销申请',
        {
          confirmButtonText: '撤销',
          cancelButtonText: '取消',
          center: true,
          dangerouslyUseHTMLString: true,
          cancelButtonClass: 'cancelWireless',
          confirmButtonClass: 'btnConfirm'
        }
      ).then(() => {
        this.cancelLoad = true
        // console.log(rowData)
        basic('ReimbursementWorkflow', 'Revocation', {
          workflowId: rowData.ID
        })
          .then(res => {
            if (res && res.Code === -1) {
              this.$message.error(res.Message)
            } else {
              this.$message.success('操作成功！')
              this.getList()
            }
            this.cancelLoad = false
          })
          .catch(err => {
            this.cancelLoad = false
          })
      })
    },
    getList () {
      this.tableLoad = true
      basic('ReimbursementWorkflow', 'Page', this.listQuery).then(res => {
        this.tableData = res.Data
        this.total = res.TotalCount
        this.rowData = null
        this.tableLoad = false
      })
    },
    clearEvent () {
      this.keyword = this.$options.data.call(this).keyword
      this.getList()
    },
    pageChange (val) {
      this.listQuery.pageNum = val
      this.getList()
    },
    filterWhere () {
      let where = '1=1'
      if (this.status) where += ` and Status=${this.status}`
      if (!this.isFinance && this.userInfo.UserName != 'Admin')
        where += ` and ApplyUserID=${this.userInfo.UserId}`
      return where
    },
    disposeUpdateQuery (field, value) {
      return new Promise((resolve, reject) => {
        let obj = { model: {}, fields: '' }
        if (Object.prototype.toString.call(field) === '[object Object]') {
          obj['model'] = { ...obj['model'], ...field }
          obj['fields'] = Object.keys(obj.model).join(',')
        } else {
          obj['model'][field] = value
          obj['fields'] = field
        }
        obj['model']['ID'] = this.rowData.ID
        basic('ReimbursementWorkflow', 'Update', obj)
          .then(_ => {
            if (_) {
              this.$message.success('操作成功！')
              this.getList()
              resolve()
            } else {
              this.$message.error('操作失败！')
              reject()
            }
          })
          .catch(err => {
            reject()
          })
      })
    },
    rowClick (row) {
      this.rowData = row
    }
  }
}
</script>
<style scoped lang="less">
.ManagerReimbursementList {
  // 修改科目弹框按钮样式
  .btnStyle {
    text-align: center;
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .pageFilter {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    .pageFilterRight {
      .NewReimbursementForm {
        border-color: #154f9d !important;
        color: #154f9d !important;
        &:hover {
          color: #fff !important;
          background: #154f9d !important;
        }
      }
    }
  }
  .yes,
  .deny {
    padding: 4px 16px;
    border-radius: 6px;
  }
  .yes {
    color: #3399ff;
    background: #f3f9ff;
  }
  .deny {
    color: #ff4141;
    background: #fff3f3;
  }
  .tabel-btns {
    :deep(.el-button + .el-button) {
      margin-left: 16px;
    }
  }
}
.dialogForm {
  padding: 16px 0 12px 0;
  :deep(.el-button) {
    width: 92px;
  }
  :deep(.el-button + .el-button) {
    margin-left: 32px;
  }
}
</style>
